import React, { useState, useRef, useLayoutEffect } from "react";
import { createPortal } from "react-dom";
import "../styles/styles.css";
import "../../../styles/global.css";

const Suggestions = ({ rowData, counters, t, verifiers }) => {
  const [hoverType, setHoverType] = useState(null);
  const [tooltipPos, setTooltipPos] = useState({ top: 0, left: 0 });
  const [triggerRect, setTriggerRect] = useState(null);

  const tooltipRef = useRef(null);
  const missingRef = useRef(null);
  const approvedRef = useRef(null);
  const rejectedRef = useRef(null);

  const verifiersNumber = verifiers?.length || 0;
  const approvedCount = counters.approved || 0;
  const rejectedCount = counters.rejected || 0;
  const missingCount = Math.max(
    verifiersNumber - (approvedCount + rejectedCount),
    0
  );

  const approvedList =
    rowData?.predlozi?.filter((p) => p.status.toLowerCase() === "odobren") ||
    [];

  const rejectedList =
    rowData?.predlozi?.filter((p) => p.status.toLowerCase() === "odbijen") ||
    [];

  const votedVerifierIds = [
    ...approvedList.map((p) => p.korisnik?.grupa?.skracenica),
    ...rejectedList.map((p) => p.korisnik?.grupa?.skracenica),
  ];

  const missingVerifiers =
    verifiers?.filter(
      (verifier) => !votedVerifierIds.includes(verifier.skracenica)
    ) || [];

  const handleMouseEnter = (type, ref) => {
    if (ref?.current) {
      const rect = ref.current.getBoundingClientRect();
      setTriggerRect(rect);
      setHoverType(type);
    }
  };

  const handleMouseLeave = () => {
    setHoverType(null);
  };

  useLayoutEffect(() => {
    if (hoverType && tooltipRef.current && triggerRect) {
      const tooltipWidth = tooltipRef.current.offsetWidth;
      setTooltipPos({
        top: triggerRect.top + window.scrollY + triggerRect.height / 2,
        left: triggerRect.left + window.scrollX - tooltipWidth - 10,
      });
    }
  }, [hoverType, triggerRect]);

  const getListContent = () => {
    if (hoverType === "missing") {
      return missingVerifiers.map((v, i) => (
        <span key={i} className="inria-sans-400 font-14">
          {v?.skracenica}
        </span>
      ));
    }

    const list = hoverType === "approved" ? approvedList : rejectedList;

    return list.map((p, i) => (
      <div key={i} className="inria-sans-400 font-14 flex-direction-row gap-4">
        <span>{p.korisnik?.ime}</span>
        <span>{p.korisnik?.prezime}</span>
        <span>{p.korisnik?.grupa?.skracenica}</span>
      </div>
    ));
  };

  return (
    <div className="flex-direction-row relative items-center gap-8">
      {missingCount > 0 && (
        <div
          ref={missingRef}
          className="suggestion-box missing pointer relative"
          onMouseEnter={(e) => {
            e.stopPropagation();
            handleMouseEnter("missing", missingRef);
          }}
          onMouseLeave={handleMouseLeave}
          onClick={(e) => {
            e.stopPropagation();
            handleMouseEnter("missing", missingRef);
          }}
        >
          <span className="suggestion-number inria-sans-400">
            {missingCount}
          </span>
        </div>
      )}

      {approvedCount > 0 && (
        <div
          ref={approvedRef}
          className="suggestion-box approved pointer relative"
          onMouseEnter={(e) => {
            e.stopPropagation();
            handleMouseEnter("approved", approvedRef);
          }}
          onMouseLeave={handleMouseLeave}
          onClick={(e) => {
            e.stopPropagation();
            handleMouseEnter("approved", approvedRef);
          }}
        >
          <span className="suggestion-number inria-sans-400">
            {approvedCount}
          </span>
        </div>
      )}

      {rejectedCount > 0 && (
        <div
          ref={rejectedRef}
          className="suggestion-box rejected pointer relative"
          onMouseEnter={(e) => {
            e.stopPropagation();
            handleMouseEnter("rejected", rejectedRef);
          }}
          onMouseLeave={handleMouseLeave}
          onClick={(e) => {
            e.stopPropagation();
            handleMouseEnter("rejected", rejectedRef);
          }}
        >
          <span className="suggestion-number inria-sans-400">
            {rejectedCount}
          </span>
        </div>
      )}

      {hoverType &&
        createPortal(
          <div
            ref={tooltipRef}
            className="suggestions-list"
            style={{
              position: "absolute",
              top: tooltipPos.top,
              left: tooltipPos.left,
              transform: "translateY(-50%)",
              zIndex: 9999,
            }}
          >
            {getListContent()}
          </div>,
          document.body
        )}
    </div>
  );
};

export default Suggestions;
